import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const pulseGlow = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(249, 55, 55, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(249, 55, 55, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 55, 55, 0);
  }
`;

type LiveDotProps = {
  size?: number;
  color?: string;
  duration?: number; // seconds
};

export const LiveDot = ({
  size = 8,
  color = '#f93737ff',
  duration = 2,
}: LiveDotProps) => {
  return (
    <Box
      role="status"
      aria-label="Live"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        animation: `${pulseGlow} ${duration}s ease-in-out infinite`,
      }}
    />
  );
};